import styled, { css } from 'styled-components';

const Tab = styled.div<{
	$selected?: boolean;
}>`
	height: 20px;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	line-height: 20px;
	color: #fff;
	opacity: 0.5;
	white-space: nowrap;
	text-align: center;

	cursor: pointer;

	${({ $selected }) =>
		$selected &&
		css`
			font-weight: bold;
			opacity: 1;
		`}

	transition: opacity 0.25s ease;
`;

export { Tab };
